Object.defineProperty(exports,"__esModule",{value:true});exports.getOutOfComplianceRules=exports.positionComplianceState=undefined;

var _types=require('./types');


var positionComplianceState=exports.positionComplianceState=function positionComplianceState(
position)
{
var rules=position.ruleIds?position.ruleIds.toRefArray():[];

var outOfComplianceRules=getOutOfComplianceRules(rules);
var type=
outOfComplianceRules.length===0?
_types.ComplianceStatus.COMPLIANT:
_types.ComplianceStatus.NON_COMPLIANT;

return{
type:type,
payload:{
since:position.noncompliantAt,
reason:position.noncompliantReason}};


};

var getOutOfComplianceRules=exports.getOutOfComplianceRules=function getOutOfComplianceRules(rules){
if(rules.length===0)return[];

return rules.filter(function(rule){return rule.status===_types.PositionRuleStatus.VIOLATION;});
};